import _ from 'underscore';
import Util from 'views/utils/LeafletMap/utils/Util';
import MapProvider from 'views/utils/LeafletMap/MapProviders/MapProvider';
import GoogleDirectionService from 'views/utils/LeafletMap/MapServices/GoogleDirectionService';
import GoogleLocationService from 'views/utils/LeafletMap/MapServices/GoogleLocationService';
import 'Map/components/mapLayerProviders/GarminGoogleMutant';

var LayerTypeMapping = {
    ROAD: 'ROADMAP',
    SATELLITE: 'SATELLITE',
    TERRAIN: 'TERRAIN',
    HYBRID: 'HYBRID'
};

var GoogleProvider = function(args, callback) {
    let scriptLoadedFunc = () => {
        this.directionService = new GoogleDirectionService({
            transitMode: args && args.transitMode ? args.transitMode : null
        });

        this.locationService = new GoogleLocationService({});

        if (callback) {
            callback();
        }
    };

    MapProvider.apply(this, arguments);
    this.name = Util.MapProviders.GOOGLE;

    new L.gridLayer.googleMutant({
        onAfterLoad: scriptLoadedFunc
    });
};

GoogleProvider.prototype = Object.create(MapProvider.prototype);
GoogleProvider.prototype.constructor = GoogleProvider;

//SHARED METHODS
GoogleProvider.prototype.getTileLayer = function getTileLayer(layerType) {
    if (layerType && LayerTypeMapping[layerType]) {
        layerType = LayerTypeMapping[layerType];
    } else {
        layerType = LayerTypeMapping.ROAD;
    }
    return layerType;
};

export default GoogleProvider;
